import { render } from "./CoursePage.vue?vue&type=template&id=7731a965&scoped=true"
import script from "./CoursePage.vue?vue&type=script&lang=js"
export * from "./CoursePage.vue?vue&type=script&lang=js"

import "./CoursePage.vue?vue&type=style&index=0&id=7731a965&lang=css"
import "./CoursePage.vue?vue&type=style&index=1&id=7731a965&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7731a965"]])

export default __exports__